import React from "react";

import { t } from "i18next";

import MccsLayout from "components/Report/HelperComponents/MCCSLayout";
import { TEST_NAME } from "constants/applicantReport";

const MCCSChatTechnicalSupport = ({ assessments }) => {
  const title = t("applicantReport.mccsChatTechnicalSupport");
  const subtitle = t("applicantReport.measuresAperson");

  const MCCSChatTechnicalSupportData = assessments.find(
    (assessment) => assessment.name === TEST_NAME.MCCS_CHAT_TECHNICAL_SUPPORT
  );

  return (
    <MccsLayout
      data={MCCSChatTechnicalSupportData}
      title={title}
      subtitle={subtitle}
    />
  );
};

export default MCCSChatTechnicalSupport;
